"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateValues_1 = require("../../utilities/dateValues/DateValues");
exports.DayOfWeek = DateValues_1.DayOfWeek;
exports.DateRangeType = DateValues_1.DateRangeType;
//# sourceMappingURL=Calendar.Props.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Calendar/Calendar.Props.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Calendar/Calendar.Props.js
// module chunks = 1